const WORKER_URL = "https://bitter-dream-164f.minartscreations.workers.dev/";

document.addEventListener("DOMContentLoaded", async () => {
  try {
    const response = await fetch(WORKER_URL);

    if (!response.ok) {
      throw new Error("Impossible de récupérer les données.");
    }

   const data = await response.json();

window.lastStudioData = data;

renderStudio(data.projects, data.capacity);


  } catch (error) {
    console.error("Studio Queue:", error);
  }
});

function renderStudio(projects, capacity) {

  const currentProjects = projects.filter(project =>
    project.status.includes("Illustrating")
  );

  const waitingProjects = projects.filter(project =>
    project.status.includes("Waiting")
  );

  const completedProjects = projects.filter(project =>
    project.status.includes("Completed")
  );

  const nextProjects = waitingProjects
    .sort((a, b) => a.position - b.position)
    .slice(0, 3);

  renderCurrentlyCreating(currentProjects);
  renderNextUp(nextProjects, capacity);
  renderWaiting(waitingProjects);
  renderCompleted(completedProjects);
  renderKindWords();

}

function getFlower(index) {

  const flowers = [
    "🌸",
    "🌷",
    "🌼",
    "🌺",
    "🪻",
    "🌻",
    "🌹",
    "💐"
  ];

  return flowers[index % flowers.length];

}


function renderCurrentlyCreating(projects) {

  const container = document.getElementById("currently-creating-container");
  const subtitle = document.getElementById("creating-subtitle");

  if (!container) return;

  container.innerHTML = "";

  const count = projects.length;

  subtitle.textContent =
    count === 1
      ? "1 magical creation is currently taking shape in the studio..."
      : `${count} magical creations are currently taking shape in the studio...`;

  projects.forEach((project, index) => {

    const card = document.createElement("div");
    card.className = "current-project";

    card.innerHTML = `

      <div class="project-title">

        <div class="project-avatar">
         ${getFlower(index)}
        </div>

        <h2 class="client-name">
          ${project.displayName}
        </h2>

      </div>

      <p class="progress-text">
        ${project.category || ""}
      </p>

      <div class="progress-wrapper">

        <div class="progress-bar">

          <div class="progress-fill" style="width:${project.progress || 0}%;">
            <span class="wand">🪄</span>
          </div>

        </div>

        <span class="progress-number">
          ${project.progress || 0}%
        </span>

      </div>

      <div class="project-eta">

        <span>📅 Estimated completion</span>

        <strong>${project.eta || "—"}</strong>

      </div>

    `;

    container.appendChild(card);


  });

}

function renderNextUp(projects, capacity) {

  const container = document.getElementById("next-up-container");
  const capacityPercent = document.getElementById("capacity-percent");
  const capacityFill = document.getElementById("capacity-fill");

  if (!container) return;

  container.innerHTML = "";

  
  if (capacityPercent) {
    capacityPercent.textContent = `${capacity}%`;
  }

  if (capacityFill) {
    capacityFill.style.width = `${capacity}%`;
  }

  projects.forEach((project, index) => {

    const card = document.createElement("div");
    card.className = `next-client card-${index + 1}`;

    const badge =
      index === 0 ? "NEXT ✨" : "COMING SOON";

    const position = String(index + 1).padStart(2, "0");

    card.innerHTML = `
      <span class="position">${position}</span>
      <span class="client">${project.displayName}</span>
      <span class="badge">${badge}</span>
    `;

    container.appendChild(card);

  });

}

function renderWaiting(projects) {

  const container = document.getElementById("waiting-list-container");

  if (!container) return;

  container.innerHTML = "";

  projects
    .sort((a, b) => a.position - b.position)
    .forEach(project => {

      const pill = document.createElement("div");
      pill.className = "waiting-pill";

      pill.textContent = `🌱 ${project.displayName}`;

      container.appendChild(pill);

    });

}

function renderCompleted(projects) {

  const container = document.getElementById("completed-gallery");

  if (!container) return;

  container.innerHTML = "";

  projects.forEach(project => {

    const card = document.createElement("div");
    card.className = "completed-item slider__slide";

    card.innerHTML = `

      <div class="completed-image">

        <img
          src="${project.image || ""}"
          alt="${project.displayName}">

      </div>

      <div class="completed-info">

        <h3>${project.displayName}</h3>

        <span class="completed-pill">
          ✔ COMPLETED
        </span>

      </div>

    `;

    container.appendChild(card);


    const image = card.querySelector("img");

image.addEventListener("click", () => {

    document.getElementById("lightbox-image").src = image.src;

    document
        .getElementById("image-lightbox")
        .classList.add("open");

    document.body.style.overflow = "hidden";

});


  });

}


function renderKindWords() {

  const track = document.getElementById("kindwords-track");

  if (!track) return;

  track.innerHTML = "";

  if (!window.lastStudioData?.reviews?.length) return;

  const reviews = window.lastStudioData.reviews;

  function createCard(review){

  const stars = "★".repeat(review.rating);

  const icons = {
    heart: '<img src="https://cdn.shopify.com/s/files/1/0605/7499/0390/files/4_1b951312-b3ec-45ec-ab24-ec51c8ca349f.png?v=1785350580" alt="">',
    star: '<img src="https://cdn.shopify.com/s/files/1/0605/7499/0390/files/3_db825e4b-0388-4de6-9004-0c764e40a623.png?v=1785355568" alt="">',
    smiley: '<img src="https://cdn.shopify.com/s/files/1/0605/7499/0390/files/2_0977fd95-829e-4c7a-a35a-39153c9f3cf3.png?v=1785355568" alt="">'
};


  return `
    <div class="kindword" tabindex="0">

      <div class="kindword-header">

        <div class="kindword-stars">
          ${stars}
        </div>

        <div class="kindword-icon">
          ${icons[review.icon] || "💖"}
        </div>

      </div>

      <h3 class="kindword-title">
        ${review.reviewTitle || ""}
      </h3>

      <div class="kindword-review">
        ${review.review}
      </div>

      <div class="kindword-footer">

        <div class="kindword-name">
          <span class="kindword-avatar">
            ${review.avatar || "🥹"}
          </span>

          <span>
            ${review.name}
          </span>
        </div>

      </div>

    </div>
  `;

}

  const html = reviews.map(createCard).join("");

track.innerHTML = html + html;

let offset = 0;
let paused = false;

const firstCard = () => track.firstElementChild;

function animate(){

    if(!paused){

        offset += 0.45;

        track.style.transform = `translateX(-${offset}px)`;

        const card = firstCard();

        if(card){

            const style = getComputedStyle(track);

            const gap = parseFloat(style.columnGap || style.gap || 22);

            const width = card.offsetWidth + gap;

            if(offset >= width){

                offset -= width;

                track.appendChild(card);

                track.style.transform = `translateX(-${offset}px)`;

            }

        }

    }

    requestAnimationFrame(animate);

}

requestAnimationFrame(animate);

track.addEventListener("mouseenter", () => paused = true);

track.addEventListener("mouseleave", () => {

    if(!track.classList.contains("paused")){

        paused = false;

    }

});

track.querySelectorAll(".kindword").forEach(card => {

    card.addEventListener("click", e => {

        e.stopPropagation();

        const alreadyOpen = card.classList.contains("expanded");

        track
            .querySelectorAll(".kindword")
            .forEach(c => c.classList.remove("expanded"));

        if(alreadyOpen){

            paused = false;

            track.classList.remove("paused");

        }else{

            card.classList.add("expanded");

            paused = true;

            track.classList.add("paused");

        }

    });

});

document.addEventListener("click", () => {

    track
        .querySelectorAll(".kindword")
        .forEach(c => c.classList.remove("expanded"));

    paused = false;

    track.classList.remove("paused");

});


document.addEventListener("click", () => {

    document
        .querySelectorAll(".kindword")
        .forEach(card => card.classList.remove("expanded"));

    track.classList.remove("paused");

});


}


const lightbox = document.getElementById("image-lightbox");

const closeButton = document.querySelector(".lightbox-close");

closeButton.addEventListener("click", closeLightbox);

lightbox.addEventListener("click", e => {

    if(e.target === lightbox){

        closeLightbox();

    }

});

document.addEventListener("keydown", e => {

    if(e.key === "Escape"){

        closeLightbox();

    }

});

function closeLightbox(){

    lightbox.classList.remove("open");

    document.body.style.overflow = "";

}

